import React, { useState } from "react";
import Instructions from "../components/Instructions";
import Minutes from "../components/Minutes";
import ParticipantBar from "../components/ParticipantBar";

const Home = () => {
  const [participants, setParticipants] = useState([]);
  const [messages, setMessages] = useState([]);
  return (
    <div className="flex justify-center h-auto">
      <Instructions messages={messages} />
      <Minutes
        participants={participants}
        messages={messages}
        setMessages={setMessages}
      />
      <ParticipantBar
        participants={participants}
        setParticipants={setParticipants}
      />
    </div>
  );
};

export default Home;
